import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Badge, Box, Divider, Paper, Tab } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import StaffInfo from './PersonDetailPanels/Staff';
import InoutInfo from './PersonDetailPanels/InoutInfo';
import InoutStaff from './PersonDetailPanels/InoutStaff';
import CovidApplication from './PersonDetailPanels/CovidApplication';
import OnlineSafetyTraining from './PersonDetailPanels/OnlineSafetyTraining';
import { Person } from '../schema/person';
import { api } from '../api';


interface StaffDetailProps {
  person_id?: string | number;
  editable?: boolean;
}

enum StaffDetailTab {
  PERSONAL = 'personal',
  INOUT = 'inout',
  COVID19 = 'cvd',
  OST = 'ost'
}

const StaffDetail: React.FC<StaffDetailProps> = ({ person_id, editable }: StaffDetailProps) => {
  const [tabValue, setTabValue] = useState<StaffDetailTab>(StaffDetailTab.PERSONAL);

  const [isCVAActive, setIsCVAActive] = useState<boolean>(true);
  const [isOSTActive, setIsOSTActive] = useState<boolean>(false);
  const [isStaff, setIsStaff] = useState<boolean>(false);

  const handleChange = (event: React.SyntheticEvent, newValue: StaffDetailTab) => {
    setTabValue(newValue);
  };

  const reloadStatus = useCallback(() => {
    if (person_id) {
      api.get(`person/${person_id}/cva/status`).then((res) => {
        const { data } = res;
        setIsCVAActive(data.is_active);
      });
      api.get(`person/${person_id}/ost/status`).then((res) => {
        const { data } = res;
        setIsOSTActive(data.is_active);
      });
    }
  }, [person_id]);

  useEffect(() => {
    if (person_id) {
      api
        .get<Person>(`/person/${person_id}`)
        .then((res) => {
          const { data } = res;
          console.log(data.company.company_type_id == 2)
          // setIsStaff(data.person_type.is_staff);
          if (data.company.company_type_id == 2 && data.person_type) {
            setIsStaff(true)
          }
        })
        .catch((res) => res.json());
    }
  }, [person_id]);

  return (
    <Box>
      <Paper sx={{ p: 2 }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange}>
              <Tab
                sx={{ textTransform: 'none' }}
                label="ข้อมูลบุคลากร"
                value={StaffDetailTab.PERSONAL}
              />
              <Tab
                sx={{ textTransform: 'none' }}
                label="การเข้า-ออกพื้นที่"
                value={StaffDetailTab.INOUT}
              />
              {isStaff && (
                <Tab
                  sx={{ textTransform: 'none' }}
                  value={StaffDetailTab.OST}
                  label={
                    isOSTActive ? (
                      'Online safety training'
                    ) : (
                      <Badge
                        color="error"
                        badgeContent=" "
                        variant="dot"
                        sx={{ '& .MuiBadge-badge': { transform: 'scale(1) translate(100%, -50%)' } }}
                      >
                        Online safety training
                      </Badge>
                    )
                  }
                />
              )}
              <Tab
                sx={{ textTransform: 'none' }}
                value={StaffDetailTab.COVID19}
                label={
                  isCVAActive ? (
                    'ข้อมูลการตรวจร่างกาย'
                  ) : (
                    <Badge
                      color="error"
                      badgeContent=" "
                      variant="dot"
                      sx={{ '& .MuiBadge-badge': { transform: 'scale(1) translate(100%, -50%)' } }}
                    >
                      ข้อมูลการตรวจร่างกาย
                    </Badge>
                  )
                }
              />
            </TabList>
          </Box>
          <TabPanel value={StaffDetailTab.PERSONAL} sx={{ p: 1, pt: 2 }}>
            <StaffInfo person_id={person_id} editable={editable} />
          </TabPanel>
          <TabPanel value={StaffDetailTab.INOUT} sx={{ p: 1, pt: 2 }}>
            <InoutStaff person_id={person_id} editable={editable} />
          </TabPanel>
          <TabPanel value={StaffDetailTab.OST} sx={{ p: 1, pt: 2 }}>
            <OnlineSafetyTraining
              person_id={person_id}
              editable={editable}
              reloadStatus={reloadStatus}
            />
          </TabPanel>
          <TabPanel value={StaffDetailTab.COVID19} sx={{ p: 1, pt: 2 }}>
              <CovidApplication
                person_id={person_id}
                editable={editable}
                reloadStatus={reloadStatus}
              />
          </TabPanel>
        </TabContext>
      </Paper>
    </Box>
  );
};

export default StaffDetail;
